(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("adaptive-expressions"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ACData"] = factory(require("adaptive-expressions"));
	else
		root["ACData"] = factory(root["AEL"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__949__) {
return 